import styled, { css } from "styled-components";
import {
  flexbox,
  FlexboxProps,
  space,
  SpaceProps,
  layout,
  LayoutProps,
  color,
  ColorProps,
  GridProps,
  grid,
} from "styled-system";

export const Box = styled.div<SpaceProps & LayoutProps & ColorProps>`
  ${space}
  ${layout}
  ${color}
`;

export const Flex = styled(Box)<
  SpaceProps & FlexboxProps & LayoutProps & ColorProps & { gap?: string }
>`
  display: flex;
  ${flexbox}
  ${({ gap }) =>
    gap &&
    css`
      gap: ${gap};
    `}
`;

export const Grid = styled(Box)<
  SpaceProps & GridProps & LayoutProps & ColorProps & { gap?: string }
>`
  display: grid;
  ${grid}
`;

export const Card = styled(Box)`
  box-shadow: 0px 2.35372px 2.35372px rgba(0, 0, 0, 0.25);
  background-color: ${({ theme }) => theme.colors.lighthouse};
  padding: 2.5rem 2rem;
`;
